import { render, staticRenderFns } from "./TripAvatar.vue?vue&type=template&id=1deeea4f&scoped=true&"
import script from "./TripAvatar.vue?vue&type=script&lang=js&"
export * from "./TripAvatar.vue?vue&type=script&lang=js&"
import style0 from "./TripAvatar.vue?vue&type=style&index=0&id=1deeea4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deeea4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1deeea4f')) {
      api.createRecord('1deeea4f', component.options)
    } else {
      api.reload('1deeea4f', component.options)
    }
    module.hot.accept("./TripAvatar.vue?vue&type=template&id=1deeea4f&scoped=true&", function () {
      api.rerender('1deeea4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trips/TripAvatar.vue"
export default component.exports